<template>
  <ul
    class="filter-list categories"
    v-if="!all_store_categories_being_loaded"
    ref="cat-nav-contianer"
    :class="{ 'no-scroll': all_store_categories.length < 1 }"
  >
    <div
      v-for="(category, index) in all_store_categories"
      :key="category._id"
      :index="index"
      :data-id="seoName(category.name)"
      :data-index="index"
    >
      <router-link
        class="category-button filter-link scrollactive-item"
        :class="{ active: index === 0 }"
        name="routerlink"
        v-if="category_products(category._id).length"
        :to="{
          name: brandStoreRoute('store_page_category'),
          params: {
            category_name: seoName(category.name),
          },
        }"
      >
        <h4 :id="'h4_' + seoName(category.name)" ref="category_link">
          {{ _T_DB(category, 'name') }}
        </h4>
      </router-link>
    </div>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'
import { seo_name, debounce, isInViewport } from '@/utils/main_utils'
import Windowsize from '@/mixins/Windowsize'
export default {
  name: 'Categories',
  mixins: [Windowsize],
  components: {},
  data() {
    return {
      showMore: false,
      moreActive: false,
      mobilecategories: false,
    }
  },

  created() {
    window.addEventListener('scroll', debounce(this.handleScroll, 10))
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    handleScroll(event) {
      let ids = {}
      document.querySelectorAll('.product-detail-box').forEach(elem => {
        //if (elemVisibleInParent(elem, container)) {
        if (isInViewport(elem)) {
          let parent = elem.closest('.category-entry').parentNode
          let visibleHeading = parent.firstChild.firstChild.id
          ids[visibleHeading] = visibleHeading
        }
      })

      this.moveElement(ids)
    },
    moveElement(ids) {
      let id = ids[Object.keys(ids)[0]]

      if (id) {
        var elems = document.querySelectorAll('.category-button')
        ;[].forEach.call(elems, function(el) {
          if (el.firstChild.id != id) {
            el.classList.remove('active')
          }
        })

        let element = document.getElementById('h4_' + id)
        let main = document.querySelector('.filter-list.categories')
        if (element) {
          element.parentNode.classList.add('active')
          main.scrollLeft = element.parentNode.parentNode.offsetLeft - 50
        }
      }
    },
    seoName(name) {
      return seo_name(name)
    },
  },
  watch: {
    $route(to, from) {
      this.$nextTick(() => {
        var elems = document.querySelectorAll('.category-button')

        ;[].forEach.call(elems, function(el) {
          el.classList.remove('active')
        })
        let main = document.querySelector('.filter-list.categories')
        let element = document.getElementById('h4_' + to.params.category_name)
        if (element && element.parentNode) {
          main.scrollLeft =
            element.parentNode.parentNode.offsetLeft - this.offsetMarginLeft
          element.parentNode.classList.add('active')
          window.scroll(
            0,
            document.getElementById(to.params.category_name).offsetTop -
              this.offsetMarginTop
          )
        }
      })
    },
  },
  mounted() {
    if (screen.width <= 760) {
      this.mobilecategories = true
    }
    this.$nextTick(() => {
      let categoryName = this.$route.params.category_name
      if (!categoryName) {
        for (let i = 0; i < this.all_store_categories.length; i++) {
          if (this.category_products(this.all_store_categories[i]._id).length) {
            categoryName = this.seoName(this.all_store_categories[i].name)
            break
          }
        }
      }
      let element = document.getElementById('h4_' + categoryName)
      if (element) {
        element.parentNode.classList.add('active')
        let main = document.querySelector('.filter-list.categories')
        main.scrollLeft =
          element.parentNode.parentNode.offsetLeft - this.offsetMarginLeft
        window.scroll(
          0,
          document.getElementById(categoryName).offsetTop - this.offsetMarginTop
        )
      }
    })
  },
  computed: {
    offsetMarginTop() {
      if (screen.width <= 760) {
        return 80
      }
      return 220
    },
    offsetMarginLeft() {
      if (screen.width <= 760) {
        return 40
      }
      return 50
    },
    categories1() {
      return [...this.all_store_categories].splice(0, 5)
    },
    categories2() {
      return [...this.all_store_categories].splice(5)
    },
    ...mapGetters([
      'all_store_categories',
      'all_store_subcategories',
      '_T',
      '_T_DB',
      'all_store_categories_being_loaded',
      'category_products',
      'brandStoreParams',
      'brandStoreRoute',
      'selected_category',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  nav#scroll-move div:nth-child(1) {
    margin-left: 20px;
  }
}
.filter-list {
  scroll-behavior: smooth;
  display: flex;
  width: 100%;
  margin-bottom: -$px1;
  width: 75%;
  overflow-x: auto;
  &.no-scroll {
    overflow-x: unset;
  }
  &::-webkit-scrollbar {
    height: $px5;
  }
  /* Track */
  &::-webkit-scrollbar-track {
    background: $scrollbar-track;
    border-radius: $px5;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb;
    border-radius: $px4;
  }
  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: darken($scrollbar-thumb, 0.1);
  }
  div {
    position: relative;
    &:first-child {
      a {
        margin-left: 0;
      }
    }
    a {
      display: flex;
      align-items: center;
      padding-bottom: $px13;
      height: auto;
      border: $px1 solid #ddd;
      padding: $px5 $px10 !important;
      border-radius: $px15;
      cursor: pointer;
      transition: all 0.5s ease;
      white-space: nowrap;
      margin-left: $px20;
      z-index: 99;
      h4 {
        color: $font-color;
        text-transform: capitalize;
        margin-bottom: 0;
        transition: all 0.5s ease;
        font-size: calc(14px + (18 - 16) * ((100vw - 320px) / (1920 - 320)));
      }
      &.active {
        // border-bottom: $px4 solid $color-primary;
        transition: all 0.5s ease;
        background: $color-primary;
        border-color: $color-primary;
        svg {
          stroke: $color-primary;
        }
        h4 {
          color: $white;
          transition: all 0.5s ease;
        }
      }
    }
    .scroll-link {
      padding: 0 !important;
      border: none;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      z-index: -1;
      opacity: 1;
    }
    // + div{
    //   margin-left: $px20;
    //  }
  }
  .svg {
    line-height: 1;
  }
  svg {
    fill: $font-color;
    margin-right: $px10;
    width: $px12;
  }
}
@media (max-width: 1367px) {
  .filter-list {
    li {
      + li {
        margin-left: $px25;
      }
    }
  }
}
@media (max-width: 1240px) {
  .filter-list {
    li {
      a {
        padding-bottom: $px5;
      }
      h4 {
        font-size: $px14;
      }
      svg {
        width: $px12;
        height: $px9;
        margin-right: $px5;
      }
      + li {
        margin-left: $px20;
      }
    }
  }
}
@media (max-width: 1199px) {
  .filter-list {
    margin-top: 0;
    li {
      display: block;
      text-align: center;
      + li {
        margin-left: $px15;
      }
      h4 {
        font-size: $px12;
      }
      &.accordion-toggle {
        .more-option {
          min-width: $px220;
        }
        h4 {
          margin-top: 0;
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .filter-list {
    width: 100%;
    white-space: nowrap;
    padding-bottom: 0;
    div {
      margin-top: 0;
      padding-bottom: $px10;
      a {
        padding: 2px 10px !important;
      }
      h4 {
        font-size: $px13 !important;
      }
      .svg {
        display: inline-block;
        padding: $px8;
        border: $px1 solid $light-border;
        border-radius: 100%;
        margin-bottom: $px5;
      }
      svg {
        margin-bottom: 0;
      }
      &.accordion-toggle {
        .more-option {
          right: 0;
          left: unset;
        }
      }
      // &.active {
      // border-bottom: $px4 solid $color-primary;
      // }
    }
  }
}
@media (max-width: 767px) {
  .filter-list {
    overflow-x: scroll;
    li {
      &.accordion-toggle {
        display: none;
      }
    }
  }
}
.body-rtl {
  nav#scroll-move div:nth-child(1) {
    margin-left: $px20;
  }
  .filter-list {
    div {
      &:first-child {
        a {
          margin-left: $px20;
        }
      }
    }
  }
}
</style>
